export const appVersion = {
    Version: "1.0.7", // should match Git tag version
    ReleaseDate: "20181120"
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app-version.ts